import moment from "moment/moment";
import DealDTO from "@/models/DealDTO";
import copyTextToClipboard from "@/service/CopyHelper";
import {reactive} from "vue";
import {event} from 'vue-gtag'

export const state = reactive({
  copyHintTimeout: null as number|null,
  copyValue: '' as string,
});

export const formatCancelTime = (deal: DealDTO): string => {
  const canceledAt = moment(new Date(deal.canceledAt));

  let seconds = canceledAt.unix() * 1000 - Date.now();
  if (seconds < 0) {
    return '00:00';
  }

  return moment.utc(seconds).format('mm:ss');
}

export const copy = (obj: any, value: string) => {
  state.copyValue = value
  copyTextToClipboard(obj, value);
  if (state.copyHintTimeout) {
    clearTimeout(state.copyHintTimeout)
  }
  state.copyHintTimeout = setTimeout(() => {
    state.copyHintTimeout = null;
  }, 1000);
}

export const requisitesUrl = (deal: DealDTO | null | undefined): URL | null => {
  const link = deal?.requisites?.requisites
  if (typeof link !== 'string' || !/^https?:\/\//i.test(link.trim())) {
    return null
  }

  try {
    return new URL(link.trim())
  } catch {
    return null
  }
}

export const openDeeplink = (deeplinks: any) => {
  event('deeplinkClicked', {})
  _openDeeplink(0, deeplinks);
}

const _openDeeplink = (index: number, deeplinks: any) => {
  const deeplink = deeplinks[index]
  event('deeplink', {link: deeplink})
  window.open(deeplink, "_self")
  index++

  if (!deeplinks[index]) {
    return;
  }


  setTimeout(() => {
    _openDeeplink(index++, deeplinks);
  }, 1000);
}